/**
 * Text colour for content sitting on an auto-assigned avatar palette bg
 * (backend AVATAR_COLORS / frontend STAFF_AVATAR_PALETTE). Brand-family
 * backgrounds use the shade-aware contrast tokens so initials stay legible on
 * light whitelabel brand colours; non-brand tints (peach, mint, unknown) keep
 * white. Class names are literal so Tailwind can detect them.
 */
const AVATAR_TEXT_BY_BG: Record<string, string> = {
  'bg-primary-400': 'text-primary-400-contrast',
  'bg-primary-500': 'text-primary-contrast',
  'bg-primary-700': 'text-primary-700-contrast',
  'bg-secondary-300': 'text-secondary-400-contrast',
  'bg-secondary-400': 'text-secondary-400-contrast',
  'bg-coral-400': 'text-coral-400-contrast',
  'bg-coral-500': 'text-coral-contrast',
};

export const avatarTextClass = (bgClass: string | null | undefined): string =>
  (bgClass && AVATAR_TEXT_BY_BG[bgClass]) || 'text-white';
